import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "userShield"
const UserShieldIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 6C14.071 6 15.75 7.679 15.75 9.75S14.071 13.5 12 13.5 8.25 11.821 8.25 9.75 9.929 6 12 6M12 7.5C10.757 7.5 9.75 8.507 9.75 9.75S10.757 12 12 12 14.25 10.993 14.25 9.75 13.243 7.5 12 7.5"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M12 1.5S16.5 4.5 21 6C21 21 12 22.5 12 22.5 11.997 22.5 3 20.998 3 6 8.249 4.5 11.999 1.501 12 1.5M12 16.5C10.228 16.5 9.02 16.854 8.273 17.186 7.931 17.337 7.683 17.487 7.521 17.599 7.865 18.069 8.216 18.47 8.56 18.814 9.536 19.79 10.5 20.35 11.203 20.662 11.54 20.81 11.814 20.9 12 20.956 12.186 20.902 12.461 20.81 12.797 20.661 13.499 20.349 14.464 19.79 15.44 18.814 15.784 18.47 16.135 18.069 16.48 17.6 16.316 17.487 16.068 17.337 15.727 17.186 14.98 16.854 13.772 16.5 12 16.5M12.058 3.313C11.605 3.627 10.987 4.035 10.229 4.48 8.787 5.328 6.821 6.33 4.518 7.1 4.654 11.359 5.576 14.302 6.71 16.334 6.942 16.18 7.257 15.995 7.664 15.814 8.605 15.397 10.022 15 12 15S15.395 15.396 16.336 15.815C16.743 15.995 17.058 16.18 17.289 16.335 18.427 14.295 19.352 11.336 19.482 7.05 17.476 6.29 15.555 5.316 14.084 4.5 13.257 4.039 12.56 3.623 12.058 3.313"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default UserShieldIcon
